import { isMainMouseButton } from '../../../../../../utils/events'
import { getCalendarGridWeekCellPointerMinutes } from '../../CalendarGridWeekCell.utils'

export function useCalendarGridWeekCellHandlers({
  day,
  hour,
  isDisabled,
  isPast,
  start,
  onClick,
  onPointerDown,
  onPointerMove,
}) {
  function handleClick() {
    if (!isDisabled) {
      onClick(start)
    }
  }

  function handlePointerDown(event) {
    if (!isPast && onPointerDown && isMainMouseButton(event)) {
      onPointerDown({
        day,
        minutes: getCalendarGridWeekCellPointerMinutes({ event, hour }),
        pointerY: event.clientY,
        start,
      })
    }
  }

  function handlePointerMove(event) {
    if (!isPast && onPointerMove) {
      onPointerMove({
        day,
        minutes: getCalendarGridWeekCellPointerMinutes({ event, hour }),
        pointerY: event.clientY,
      })
    }
  }

  return {
    handleClick,
    handlePointerDown,
    handlePointerMove,
  }
}
